define(
	'C3.ShoppingExtensions.LoginRegister.Register.Model',
	[
		'SCModel',
		'Utils'
	],
	function(SCModelComponent, Utils){
		'use strict';

		var SCModel = SCModelComponent.SCModel;

		function LoginRegisterRegisterModel() {
			SCModel.call(this);

			// Define properties of the model.
			this.urlRoot = function() {
				return Utils.getAbsoluteUrl(
					getExtensionAssetsPath("services/popupRegister.ss")
				)
			}

			this.validation = function() {
				return {
					firstname: {
		                required: true,
		                msg: Utils.translate('First Name is Required')
		            },
		            lastname: {
		                required: true,
		                msg: Utils.translate('Last Name is Required')
		            },

		            ima: {
			                fn: function(val) {
			                   //console.log(val)
			                   if(val == 'Select one' || val == undefined)
			                    return Utils.translate('Category is Required');
			                }
			            },
			            
		            custentity_destination_country: {
			                fn: function(val) {
			                   //console.log(val)
			                   if(val == 'Select one' || val == undefined)
			                    return Utils.translate('Country is Required');
			                }
			            },
		            custentity_customer_state: {
		                 fn: function(value,name,form) {
		                   //console.log(form.custentity_destination_country)

		                   if(form.custentity_destination_country != undefined && (form.custentity_customer_state == undefined || form.custentity_customer_state == 'Select one'))
		                    return Utils.translate('State is Required');                  
		                }
		            },
		            email: [
		                {
		                    required: true,
		                    msg: 'Email Address is Required'
		                },
		                {
		                    pattern: 'email',
		                    msg: 'Valid email address is required'
		                }
		            ],
		            password: {
		            required: true,
		            msg: Utils.translate('Please enter a valid password')
		            },
		            password2: [
		                {
		                    required: true,
		                    msg: Utils.translate('Confirm password is required')
		                },
		                {
		                    equalTo: 'password',
		                    msg: Utils.translate('New Password and Confirm Password do not match')
		                }
		            ]
				}
			}
		}

		LoginRegisterRegisterModel.prototype = Object.create(SCModel.prototype);

		LoginRegisterRegisterModel.prototype.constructor = LoginRegisterRegisterModel;

		// Return the AMD constructor.
		return LoginRegisterRegisterModel;
	}
);
